import { v5 as uuidv5 } from 'uuid';

import { canonicalReportPrototypeId } from './reportPrototypePages';

/** The Library identity svc-reporting gives a native page: UUIDv5 of its URL under the URL namespace. */
export function nativeLensId(pageId: string): string {
  return uuidv5(`https://admin.luxuryescapes.com/native-lenses/${canonicalReportPrototypeId(pageId)}`, uuidv5.URL);
}
